document.addEventListener("codeblackbelt:frequently-bought-together:rendered", () => {
    updateFormSizing = () => {
        const bundleFormParent = document.querySelector(".cbb-frequently-bought-container")
        const bundleForm = document.querySelector(".cbb-frequently-bought-form")

        if(!bundleFormParent || !bundleForm) return false

        const height = bundleForm.offsetHeight

        bundleFormParent.style.setProperty('--form-height', height + "px");

        document.dispatchEvent(new Event("clear-bundle-interval"))
    }

    updateFormSizing()

    window.addEventListener("resize", updateFormSizing)
    document.addEventListener("DOMContentLoaded", updateFormSizing)

    const interval = window.setInterval(updateFormSizing, 1000)

    document.addEventListener("clear-bundle-interval", () => {
        clearInterval(interval)
    })
})
